<template>
    <gofix-card class="cardTable chartOfAccount" fullContent>
        <gofix-default-table
                :column-width-setting="columnWidthSetting"
                :settings="tableConfig"
                :table-items="tableItems"
                :column-setting-contract-id="general.contract_id"
                @load-items="getTableData"
                @new-item="showModalMassSchedule"
                @export="exportItems"
                @import-items="importItems"
                @get-all-column-settings="getColumnSettings"
                @change-selected="changeSelectedTable"
                ref="gofixTable">
            <template slot="gofix_table:after-control-left" slot-scope="data">
                <template v-if="settings.showBtnMassSchedule">
                    <gofix-button id="gofix-button-mass" class="ml-2" label="Mass Schedule" @click="showModalMassSchedule" outline></gofix-button>
                    <gofix-button id="gofix-button-pre" class="ml-2" label="Pre-Assign Supplier" @click="assignItems" outline></gofix-button>
                    <gofix-button id="gofix-button-download" class="ml-2" label="Download Report" @click="modal.reportFomat.open = true" outline></gofix-button>
                    <b-tooltip target="gofix-button-mass" title="Mass Schedule"></b-tooltip>
                    <b-tooltip target="gofix-button-pre" title="Pre-Assign Supplier"></b-tooltip>
                    <b-tooltip target="gofix-button-download" title="Download Report"></b-tooltip>
                </template>
            </template>
            <template slot="gofix_table:before-control-right" slot-scope="data" v-if="settings.showDropDownMaint">
                <div class="mr-2 d-flex align-items-center filterCompany filterMaint">
                    <span class="mr-1 title">Maint. Program</span>
                    <gofix-form-dropdown
                            :class="[ 'highlightDropdown chartOfAccountDropdown min-width-0', classInput ]"
                            label=""
                            vLabel="description_one"
                            :clearable="false"
                            :filterable="false"
                            :options="maintPrograms"
                            v-model="maintProgram"
                            :placeholder="'Maint. Program'"
                            @search="searchMaintProgram">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                        </template>
                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                            <div class="maintOption">
                                <!-- <p><strong>{{ option.sor_code }}</strong></p> -->
                                <span>{{ option.description_one || '-' }}</span>
                            </div>
                        </template>
                    </gofix-form-dropdown>
                </div>
            </template>
            <template slot="gofix_table:before-control-right-setting" slot-scope="data" v-if="general.contract_id">
              <b-dropdown-item @click="modalImport.open = true">Import Back date job</b-dropdown-item>
              <b-dropdown-item @click="openImportSchedule">Import Monthly Jobs</b-dropdown-item>
            </template>
            <template :slot="'gofix_table:' + field.key" slot-scope="row" v-if="field.key != 'actions'" v-for="field in columnSettings">
                <template v-if="field.key == 'tag_name'">
                    <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${general.contract_id}/equipment/${row.item.id}`">
                       <span class="text-decoration-underline">{{ row.item.tag_name }}</span>
                    </router-link>
                </template>
                <template v-if="field.key == 'equipment_type'">
                   {{ row.item.equipment_type ? row.item.equipment_type : '--' }}
                </template>
                <template v-if="field.key == 'upcoming_service'">
                    <template v-if="row.item.coming_job && row.item.coming_job.planned_date">
                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.coming_job.client_contract_id}/maintenance-program/${row.item.coming_job.maintenance_id}?tab=maint_schedule&contract_id=${row.item.coming_job.client_contract_id}&schedule_id=${row.item.coming_job.schedule_id}`">
                           <span class="text-decoration-underline">{{ row.item.coming_job.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                        </router-link>
                    </template>
                    <template v-else>
                        <gofix-button
                            outline
                            class="btnUpcomingService"
                            label="Schedule"
                            :disabled="(!isEquipmentSchedule && equipment_ids.length > 0 && !equipment_ids.includes(row.item.id)) || row.item.coming_job != null"
                            @click="showModalMassSchedule(row.item)"></gofix-button>
                    </template>
                </template>
                <template v-if="field.key == 'coming_job'">
                    <template v-if="row.item.coming_job && row.item.coming_job.job_number">
                        <router-link target="_blank" class="text-dark" :to="`/v2/job-list/${row.item.coming_job.id}`">
                           <span class="text-decoration-underline">{{ row.item.coming_job.job_number }}</span>
                        </router-link>
                    </template>
                </template>
                <template v-if="field.key == 'root_path'">
                    {{ row.item.location_info ? row.item.location_info.root_path : '--' }}
                </template>
                <template v-if="field.key == 'contractor'">
                    {{ row.item.coming_job_annual && row.item.coming_job_annual.supplier ? row.item.coming_job_annual.supplier : row.item.coming_job_five_year && row.item.coming_job_five_year.supplier ? row.item.coming_job_five_year.supplier : '' }}
                </template>
                <template v-if="field.key == 'team_in_charge_name'">
                    {{ row.item.coming_job_annual && row.item.coming_job_annual.team_in_charge_name ? row.item.coming_job_annual.team_in_charge_name : row.item.coming_job_five_year && row.item.coming_job_five_year.team_in_charge_name ? row.item.coming_job_five_year.team_in_charge_name : '' }}
                </template>
                <template v-if="field.key == 'staff_in_charge_name'">
                    {{ row.item.coming_job_annual && row.item.coming_job_annual.staff_in_charge_name ? row.item.coming_job_annual.staff_in_charge_name : row.item.coming_job_five_year && row.item.coming_job_five_year.staff_in_charge_name ? row.item.coming_job_five_year.staff_in_charge_name : '' }}
                </template>
                <!-- Annual -->
                <template v-if="field.key == 'last_activity_annual'">
                    <template v-if="row.item.last_job_annual && row.item.last_job_annual.planned_date">
                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.last_job_annual.client_contract_id}/maintenance-program/${row.item.last_job_annual.maintenance_id}?tab=maint_schedule&contract_id=${row.item.last_job_annual.client_contract_id}&schedule_id=${row.item.last_job_annual.schedule_id}`">
                           <span class="text-decoration-underline">{{ row.item.last_job_annual.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                        </router-link>
                    </template>
                </template>
                <template v-if="field.key == 'upcoming_activity_annual'">
                    <template v-if="row.item.coming_job_annual && row.item.coming_job_annual.planned_date">
                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.coming_job_annual.client_contract_id}/maintenance-program/${row.item.coming_job_annual.maintenance_id}?tab=maint_schedule&contract_id=${row.item.coming_job_annual.client_contract_id}&schedule_id=${row.item.coming_job_annual.schedule_id}`">
                           <span class="text-decoration-underline">{{ row.item.coming_job_annual.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                        </router-link>
                    </template>
                    <template v-else>
                        <gofix-button
                            outline
                            class="btnUpcomingService"
                            label="Schedule"
                            :disabled="(
                                !isEquipmentSchedule && maintProgram && maintProgram.id != 'all' &&
                                (
                                    !equipment_ids.length ||
                                    (
                                        equipment_ids.length > 0 && !equipment_ids.includes(row.item.id)) ||
                                        row.item.coming_job_annual != null
                                    )
                                )"
                            @click="showModalMassSchedule(row.item, '1Y')"></gofix-button>
                    </template>
                </template>
                <!-- Five year -->
                <template v-if="field.key == 'last_activity_five_year'">
                    <template v-if="row.item.last_job_five_year && row.item.last_job_five_year.planned_date">
                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.last_job_five_year.client_contract_id}/maintenance-program/${row.item.last_job_five_year.maintenance_id}?tab=maint_schedule&contract_id=${row.item.last_job_five_year.client_contract_id}&schedule_id=${row.item.last_job_five_year.schedule_id}`">
                           <span class="text-decoration-underline">{{ row.item.last_job_five_year.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                        </router-link>
                    </template>
                </template>
                <template v-if="field.key == 'upcoming_activity_five_year'">
                    <template v-if="row.item.coming_job_five_year && row.item.coming_job_five_year.planned_date">
                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.coming_job_five_year.client_contract_id}/maintenance-program/${row.item.coming_job_five_year.maintenance_id}?tab=maint_schedule&contract_id=${row.item.coming_job_five_year.client_contract_id}&schedule_id=${row.item.coming_job_five_year.schedule_id}`">
                           <span class="text-decoration-underline">{{ row.item.coming_job_five_year.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                        </router-link>
                    </template>
                    <template v-else>
                        <gofix-button
                            outline
                            class="btnUpcomingService"
                            label="Schedule"
                            :disabled="(
                                !isEquipmentSchedule && maintProgram && maintProgram.id && maintProgram.id != 'all' &&
                                (
                                    !equipment_ids.length ||
                                    (
                                        equipment_ids.length > 0 && !equipment_ids.includes(row.item.id)) ||
                                        row.item.coming_job_five_year != null
                                    )
                                )"
                            @click="showModalMassSchedule(row.item, '5Y')"></gofix-button>
                    </template>
                </template>
                <!--tags-->
                <template v-if="field.key == 'tags'">
                    <template v-if="row.item.tags">
                        {{row.item.tags.join(', ')}}
                    </template>
                </template>
                <template v-if="field.is_customfield">
                  {{row.item.custom_fields | getCustomValue(field.attribute_id,field.customfield.type)}}
                </template>
                <template v-if="(isEquipmentSchedule && ['constituency', 'block_no', 'postal_code', 'lift_no'].includes(field.key))">
                  {{row.item.custom_fields | displayFollowCustomField(field.key)}}
                </template>
            </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open" @close="() => {
            this.modal.data.maintenance = null;
        }">
            <b-form class="pb-20">
                <template v-if="isEquipmentSchedule">
                    <gofix-form-properties
                            label="Location"
                            :contract-id="general.contract_id"
                            :property-id="general.root_property_id"
                            :valueFormat="'object'"
                            showIconRequired
                            v-model="property">
                    </gofix-form-properties>
                </template>
                <template v-else>
                    <gofix-form-dropdown
                        label="Maintenance Program"
                        vLabel="description_one"
                        :filterable="false"
                        :append-to-body="true"
                        :options="popupMaintPrograms"
                        v-model="modal.data.maintenance"
                        placeholder=" "
                        @search="searchMaintProgram">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                        </template>
                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                            <div class="maintOption">
                                <span>{{ option.description_one || '-' }}</span>
                            </div>
                        </template>
                    </gofix-form-dropdown>
                </template>
                <gofix-form-dropdown
                    label="Equipment Tag(s)"
                    class-label="text-transform-none"
                    :filterable="false"
                    :append-to-body="true"
                    :class="[{'run-loading small-loading': equipment_loading} ]"
                    v-model="modal.data.equipment_list"
                    :options="equipments"
                    vLabel="tag_name"
                    :multiple="true"
                    :disabled="modal.status"
                    @search="searchEquipment"
                    :selectable="option => {
                        if(!modal.equipment_ids.length || ( modal.equipment_ids.length > 0 && !modal.equipment_ids.includes(option.id))) {
                            return false;
                        }
                        return true;
                    }">
                </gofix-form-dropdown>
                <gofix-form-input-date
                    v-model="modal.data.date"
                    label="Date">
                </gofix-form-input-date>
                <template v-if="!isEquipmentSchedule">
                    <b-form-checkbox v-model="modal.data.is_create_individual" class="checkbox-main-allow"><span class="ml-2">Create individual schedule for each equipment</span></b-form-checkbox>
                </template>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="checkScheduledJob" :disabled="modal.loading" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" @hide="hiddenModalImport" title="import file" ref="modal-Import" id="modal-Import" hide-footer>
            <b-form>
                <b-form-group>
                    <b-form-file @input="chaneFile" placeholder="Click Browse to upload file" :state="isCheckImport" ref="file-input-structure" accept=".csv" v-model="fileImport" >
                        <template slot="file-name" slot-scope="{ names }">
                            <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="uploadFileImport" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <!--Modals-->
        <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="assign supplier" hide-footer :centered="true" v-model="modal.assign.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-supplier
                                label="Choose Supplier"
                                :contract-id="modal.assign.contract_id"
                                :required="true"
                                v-model="modal.assign.supplierAssign">
                        </gofix-form-supplier>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="assignSupplier" :loading="modal.assign.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- Modal Schedule Job -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.checkSchedule.open">
            <div v-if="is_same_date == false" class="center pb-4 pl-2 pr-2">These equipment already had<br><strong>a schedule</strong></div>
            <div v-if="is_same_date == true" class="center pb-4 pl-2 pr-2">There is already a current <b>Due or Stated</b> job for the same Equipment with the same <b>Planned Date</b></div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.checkSchedule.open = false">Cancel</b-button>
                <b-button v-if="is_same_date == false" class="custom-btn" :disabled="modal.loading"  @click="overrideAssetManagement">
                    <b-spinner small type="grow" v-if="modal.loading"></b-spinner>Override
                </b-button>
            </b-button-group>
        </b-modal>
      <b-modal :no-close-on-backdrop="true" @hide="resetImport" title="import file" id="modal-Import" hide-footer v-model="modalImport.open">
        <b-form>
          <b-form-group>
            <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="modalImport.check" ref="file-input-bdj" accept=".csv" v-model="modalImport.file" >
              <template slot="file-name" slot-scope="{ names }">
                <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
              </template>
            </b-form-file>
          </b-form-group>

          <b-button-group class="d-block text-right">
            <gofix-button label="SUBMIT" @click="importBackDateJob" :loading="modalImport.loading"  noBorder></gofix-button>
          </b-button-group>
        </b-form>
      </b-modal>

      <b-modal :no-close-on-backdrop="true" id="modal-Remove" dialog-class="modal-confirm-update" hide-footer hide-header :centered="true" v-model="modal.reportFomat.open">
        <div class="center px-4 pt-3 pb-4">
          <h4 class="mb-2">Please select report fomat</h4>
        </div>
        <b-button-group class="btn-group">
          <b-button class="custom-btn" @click="downloadReport('report_path')">Original Format</b-button>
        </b-button-group>
        <b-button-group class="btn-group">
          <b-button class="custom-btn" @click="reportJobBCA('pre092022')">BCA format</b-button>
        </b-button-group>
        <b-button-group class="btn-group">
          <b-button class="custom-btn" @click="reportJobBCA('092022')">BCA Format (September Version)</b-button>
        </b-button-group>
        <b-button-group class="btn-group">
          <b-button class="custom-btn" @click="downloadReportLiftPerAge()">Dowload lifts per Age</b-button>
        </b-button-group>
        <b-button-group class="btn-group">
          <b-button class="custom-btn" @click="modal.reportFomat.open = false">Cancel</b-button>
        </b-button-group>
      </b-modal>

      <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="downloadingModal.title" hide-footer :centered="true" v-model="downloadingModal.open" hide-header-close>
        <b-progress :max="100" height="3rem" show-progress animated>
          <b-progress-bar :value="100">
            <span class="font-size-16">Loading</span>
          </b-progress-bar>
        </b-progress>
      </b-modal>

        <!-- // -->
        <b-modal :no-close-on-backdrop="true" title="Reschedule" id="modal-Reschedule" hide-footer :centered="true" v-model="modal.rescheduled.open">
            <b-form>
                <b-form-group>
                    <gofix-text-field label="Start Date:" oneline>
                        {{ this.modal.data.date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}
                    </gofix-text-field>
                </b-form-group>
                <b-form-group class="mb-0">
                    <gofix-form-input label="Reason" :required="true" v-model="modal.rescheduled.reason_rescheduled"></gofix-form-input>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="RESCHEDULE" @click="reScheduledClick" :loading="modal.rescheduled.loading" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <!--  -->
        <b-modal :no-close-on-backdrop="true" title="" id="modal-Errors" hide-footer hide-header :centered="true" v-model="modal.errors.open">
            <div>
               <p>Mass schedule cannot proceed due to existing expired/started jobs:</p>
                <ul>
                    <li v-for="(item, index) in modal.errors.list">
                        {{ item.equipment_name }} have (1) expired job
                    </li>
                </ul>
                <p>Kindly reschedule the expired jobs or complete the started jobs for the respective equipment.</p>
                <p class="text-center mb-0"><gofix-button label="Close" @click="modal.errors.open = false" noBorder></gofix-button></p>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" id="modal-Import" title="import file" hide-footer v-model="modal.importSchedule.open">
            <b-form>
                <gofix-form-dropdown
                    label="Maintenance Program"
                    vLabel="description_one"
                    :filterable="false"
                    :append-to-body="true"
                    :options="popupMaintPrograms"
                    v-model="modal.importSchedule.data.maintenance"
                    placeholder=" "
                    @search="searchMaintProgram">
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <div class="maintOption">
                            <span>{{ option.description_one || '-' }}</span>
                        </div>
                    </template>
                </gofix-form-dropdown>
                <b-form-group>
                    <b-form-file placeholder="Click Browse to upload file" :state="modal.importSchedule.file ? false : true" ref="file-input-schedule" accept=".csv" v-model="modal.importSchedule.file" >
                    <template slot="file-name" slot-scope="{ names }">
                        <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                    </template>
                    </b-form-file>
                </b-form-group>

                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="importSchduledJobs" :loading="modal.importSchedule.loading"  noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>

    </gofix-card>
</template>

<script>
    import { mapGetters } from "vuex";
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';
import { isBuffer } from "lodash";

    export default {
        name: "equipment-schedule",
        props: {
            nameTable: {
                type: String,
                default: "client-contract-asset-management"
            },
            settings: {
                type: Object,
                default: {
                    showBtnMassSchedule: false,
                    showDropDownMaint: false,
                    create: false
                }
            },
            general: {
                type: Object,
                default: {
                    contract_id: null,
                    contract_term_id: null,
                    property_id: null,
                    equipment_group_id: null
                }
            },
            maintData: {
                type: Object,
                default: null
            },
            isEquipmentSchedule: {
                type: Boolean,
                default: false
            }
        },
        components: {
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['equipment_schedule']));
            return {
                columnWidthSetting:
                {
                    leftWidth:5,
                    rightWidth:7
                },
                columnSettings: [],
                tableConfig:{
                    dataSelect: {
                        certificate_expiry_month: {
                            value: [
                                {value: 'Jan', text: 'Jan'},
                                {value: 'Feb', text: 'Feb'},
                                {value: 'Mar', text: 'Mar'},
                                {value: 'Apr', text: 'Apr'},
                                {value: 'May', text: 'May'},
                                {value: 'Jun', text: 'Jun'},
                                {value: 'Jul', text: 'Jul'},
                                {value: 'Aug', text: 'Aug'},
                                {value: 'Sep', text: 'Sep'},
                                {value: 'Oct', text: 'Oct'},
                                {value: 'Nov', text: 'Nov'},
                                {value: 'Dec', text: 'Dec'}
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    },
                    name: this.nameTable,
                    controls:{
                        create: false,
                        delete: false,
                        tableExport: true,
                    },
                    filter: filter,
                    buildFilter: true,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                    fields: [
                        {
                            key: 'actions',
                            label: "",
                            thStyle: "width: 50px"
                        },
                        {
                            key: 'tag_name',
                            label: 'Equip. Tag',
                            thStyle: "width: 150px",
                            isActive: true,
                            isFilter: true
                        },
                        {
                            key: 'equipment_type',
                            label: 'Equip. Type',
                            thStyle: "width: 175px",
                            isActive: true,
                            isFilter: true
                        },
                        {
                            key: 'address_prefix',
                            label: 'Address Prefix',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'block',
                            label: 'Block',
                            thStyle: "width: 135px"
                        },
                         {
                            key: 'lift_letter',
                            label: 'Lift No',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'address',
                            label: 'Address',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'lift_company',
                            label: 'Lift Company',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'brand',
                            label: 'Brand',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'lift_turn_on_date',
                            label: 'Turn On Date',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'load_capacity',
                            label: 'Load Capacity',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'speed_capacity',
                            label: 'Speed Capacity',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'last_service',
                            label: 'Last Service',
                            thStyle: "width: 135px"
                        },
                        {
                            key: 'upcoming_service',
                            label: 'Upcoming Service',
                            thStyle: "width: 175px"
                        },
                    ]
                },
                tableItems:[],
                equipment_ids: [],
                equipments: [],
                equipment_loading: false,
                pagesEquipment: {
                    isCMS: '1',
                    limit: 100,
                    page: 1,
                    totalPage: 0,
                    filter: JSON.parse(JSON.stringify(filters['equipment']))
                },
                property: null,
                showFieldLocation: false,
                maintProgram: {
                    id: 'all',
                    description_one: 'All'
                },
                maintPrograms: [],
                popupMaintPrograms: [],
                isAction: false,
                fileImport: null,
                fileName: 'Click Browse to upload file',
                isCheckImport: false,
                job_id:null,
                modal:{
                    title: 'Equipment Maintenance Schedule',
                    open: false,
                    loading: false,
                    status:false,
                    ids: [],
                    equipments:[],
                    equipment_ids: [],
                    data: {
                        maintenance_id: null,
                        client_contract_id: null,
                        date: null,
                        equipment_list: [],
                        maintenance: null,
                        is_create_individual: false,
                    },
                    assign:{
                        open:false,
                        loading: false,
                        clients:[],
                        generate_order:false,
                        supplierAssign: null,
                        optionsSupplier: [],
                        tierLevel: 1,
                        ids: [],
                        tiers: [],
                        filter: null,
                        time: null,
                        job_id:null,
                        contract_id: null,
                        equipment_list:null
                    },
                    checkSchedule: {
                        open: false,
                    },
                    rescheduled: {
                        open: false,
                        loading: false,
                        ids: [],
                        reason_rescheduled: null,
                    },
                    errors: {
                        open: false,
                        list: []
                    },
                    reportFomat:{
                        open:false,
                        loading: false
                    },
                    importSchedule:{
                        open:false,
                        loading: false,
                        file:null,
                        data: {
                            maintenance: null,
                        }
                    },
                },
                timer: {
                    maint: null,
                    modal: null,
                    equipment: null
                },
                tierLevel: 1,
                classInput: "width-175",
                innerWidth: 0,
              modalImport:{
                open:false,
                loading: false,
                check:'',
                file:null,
                fileName: "Click Browse to upload file"
              },
              downloadingModal : {
                open: false,
                title: 'Downloading',
              },
              is_same_date: false
            }
        },
        filters: {
            displayFollowCustomField: function(val, key_tmp, formatDate = "DD/MM/YYYY") {
                if(val) {
                    let arr = val;
                    let type_name = key_tmp.replaceAll('_', ' ');
                    type_name = type_name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                    let filter = arr.filter(item => 
                        (key_tmp == 'block_no' && ['Block Number', 'Block No'].includes(item.attribute.name)) || 
                        (key_tmp == 'lift_no' && ['Lift Letter', 'Lift No', 'Lift Number'].includes(item.attribute.name)) || 
                        (!['block_no', 'lift_no'].includes(key_tmp) && item.attribute.name == type_name)
                    );
                    if(filter.length > 0) {
                        if(filter[0].value) {
                             if(filter[0].type == 'DateTime') {
                                return moment(new Date(filter[0].value)).format(formatDate)
                            }
                            return filter[0].value;
                        }
                    }
                }
                return;
            },
          getCustomValue: function (value, key,type) {
            if (value && Array.isArray(value)) {
              for (var i = 0; i < value.length; i++) {
                if (value[i].attribute_id === key) {
                  if(type === "DateTime"){
                    if(value[i].value){
                      return moment(value[i].value, "YYYY-MM-DD").format("DD.MM.YYYY");
                    }
                  }
                  return value[i].value;
                }
              }
            } else {
              return "";
            }
          }
        },
        watch: {
            fileImport: function(val, old) {
                if (val) {
                    let arrExtionsionAccept = ['csv']
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();


                    if(!arrExtionsionAccept.includes(extension)) {
                        this.$refs['file-input-structure'].reset()
                        return this.$alertNotification("File format is incorrect. Please select a .csv file!", "primary");
                    }
                    return this.fileName = val.name;
                }
                return this.fileName = 'Please select file to upload'
            },
            property: function(val) {
                if(val) {
                    this.getEquipment(val.id);
                }
            },
            maintData: function(val) {
                if(val) {
                    this.maintProgram = JSON.parse(JSON.stringify(val));
                }
            },
            maintProgram: function(val) {
                if(val && val.id != 'all') {
                    if(!this.settings.showDropDownMaint) {
                        this.general.property_id = val.property_id;
                        this.general.equipment_group_id = val.equipment_group_id;
                        this.general.root_property_id = val.equipment_group_id;
                        this.general.root_equipment_group_id = val.equipment_group_id;
                    }

                    this.$refs.gofixTable.reloadTableKeepFilter();
                } else {
                    this.general.property_id = 0;
                    this.general.equipment_group_id = 0;
                    this.general.root_property_id = 0;
                    this.general.root_equipment_group_id = 0;
                    this.equipments = [];
                    this.equipment_ids = [];
                    this.reloadEquipment();
                }

                this.updateColumnSettings();
                if(this.settings.showDropDownMaint) {
                    this.$emit("change-maint", val);
                }
            },
            "modal.data.maintenance": function(val, old) {
                if(val && ( (this.maintProgram && this.maintProgram.id == 'all') || old ) ) {
                    this.getEquipment();
                    //this.reloadEquipment();
                }
            },
            "general.contract_id": function(val) {
                this.maintProgram = null;
                if(val) {
                    //this.getEquipment();
                    this.reloadEquipment();
                }
            },
            "general.contract_term_id": async function(val) {
                if(val && this.settings.showDropDownMaint) {
                    await this.getMaintProgram();
                    this.maintProgram = await {
                        id: 'all',
                        description_one: 'All'
                    };
                } else {
                    this.maintPrograms = [];
                }
            },
            "general.property_id": function(val) {
                if(val) {
                    //this.getEquipment();
                    this.reloadEquipment();
                }
            },
            "general.equipment_group_id": function(val) {
                if(val) {
                    //this.getEquipment();
                    this.reloadEquipment();
                }
            },
          "modalImport.file": function(val, old) {
            if (val) {
              let arrExtionsionAccept = ['csv']
              let split = val.name.split('.');
              let extension = split[split.length - 1].toLowerCase();
              if(!arrExtionsionAccept.includes(extension)) {
                this.$refs['file-input-bdj'].reset();
                return this.$alertNotification("File format is incorrect. Please select a .csv file!", "primary");
              }
              return this.modalImport.fileName = val.name;
            }
            return this.modalImport.fileName = 'Click Browse to upload file'
          },
            innerWidth: function(val) {
                this.$nextTick(() => {
                    if(val <= 1680) {
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-mass');
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-pre');
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-download');
                    } else {
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-mass');
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-pre');
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-download');
                    }
                })
            },
            "modal.importSchedule.file": function(val, old) {
                if (val) {
                    let arrExtionsionAccept = ['csv']
                    let split = val.name.split('.');
                    let extension = split[split.length - 1].toLowerCase();
                    if(!arrExtionsionAccept.includes(extension)) {
                        this.$refs['file-input-schedule'].reset();
                        return this.$alertNotification("File format is incorrect. Please select a .csv file!", "primary");
                    }
                }
            },
        },
        computed: {
            ...mapGetters({
                ClientContractID: "ContractController/ClientContractID"
            })
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        created() {
            this.tableConfig.controls.create = this.settings.create;
            if(this.settings.title_modal) {
                this.modal.title = this.settings.title_modal
            }
            if(this.general.contract_term_id && this.settings.showDropDownMaint) {
                this.getMaintProgram();
            }

            if(this.maintData) {
                this.maintProgram = JSON.parse(JSON.stringify(this.maintData));
            }

            //this.getEquipment();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            changeSelectedTable(val) {
                this.modal.ids = val.map(item => item.id);
                this.modal.equipments = val
            },

            downloadReport(formatType = 'report_path'){
                this.modal.reportFomat.open = false
                if(this.modal.equipments.length === 0){
                    return this.$alertNotification("Please select a record!", "danger");
                }
                let equipments = this.modal.equipments;
                var job = [];
                equipments.forEach(function(item) {
                    if(item.coming_job_annual){
                        job.push(item.coming_job_annual.id);
                    }
                    if(item.coming_job_five_year){
                        job.push(item.coming_job_five_year.id);
                    }
                    if(item.last_job_annual){
                        job.push(item.last_job_annual.id);
                    }
                    if(item.last_job_five_year){
                        job.push(item.last_job_five_year.id);
                    }
                });
                if(job.length === 0){
                    return this.$alertNotification("No available job for report", "danger");
                }
                var nameFile = `report-${moment().format('DD-MMM-YYYY')}.zip`;
                this.$store.dispatch("JobController/reportJob", {
                    id: job,
                    mutil_file: true,
                    format_type: formatType,
                })
                .then(response => {
                    if(response.data.size === 0) {
                        this.$alertNotification("Blank report", "warning");
                        return;
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();
                });
            },
        async reportJobBCA(version = '092022'){
            this.modal.reportFomat.open = false
            if(this.modal.equipments.length === 0){
              return this.$alertNotification("Please select a record!", "danger");
            }
            let equipments = this.modal.equipments;
            var job = [];
            equipments.forEach(function(item) {
              if(item.coming_job_annual){
                job.push(item.coming_job_annual.id);
              }
              if(item.coming_job_five_year){
                job.push(item.coming_job_five_year.id);
              }
              if(item.last_job_annual){
                job.push(item.last_job_annual.id);
              }
              if(item.last_job_five_year){
                job.push(item.last_job_five_year.id);
              }
            });
            if(job.length === 0){
              return this.$alertNotification("No available job for report", "danger");
            }
            var nameFile = `report-${moment().format('DD-MMM-YYYY')}.zip`;
            this.downloadingModal.open = true;
            await this.$store.dispatch("JobController/reportJobBCA", {
              ids: job,
              version: version,
              mutil_file: true,
            })
                .then(response => {
                  if(response.data.size === 0) {
                    this.$alertNotification("Blank report", "warning");
                    return;
                  }
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', nameFile);
                  document.body.appendChild(link);
                  link.click();
                });
            this.downloadingModal.open = false;
          },
            handleResize() {
                this.innerWidth = window.innerWidth;
                this.classInput = "width-175";
                if (window.innerWidth < 1500) {
                    this.classInput = "width-99"
                }
            },
            updateColumnSettings() {
                let field_remove = ['last_activity_annual', 'upcoming_activity_annual', 'last_activity_five_year', 'upcoming_activity_five_year'];
                if(this.maintProgram) {
                    if(this.maintProgram.id == 'all')
                        field_remove = [];
                    if(this.maintProgram.get_sor_recurring_mode && this.maintProgram.get_sor_recurring_mode.recurring_mode == '1Y')
                        field_remove = ['last_activity_five_year', 'upcoming_activity_five_year'];
                    if(this.maintProgram.get_sor_recurring_mode && this.maintProgram.get_sor_recurring_mode.recurring_mode == '5Y')
                        field_remove = ['last_activity_annual', 'upcoming_activity_annual'];
                }

                let field = this.columnSettings.filter(item => !field_remove.includes(item.key));
                this.$refs.gofixTable.updateColumnSettings(field);
            },
            getColumnSettings(settings){
                this.columnSettings = settings;
            },
            getSupplier(){
                this.$store.dispatch("MiscExpensesController/getRelateSupplier",{
                    contract_id:this.modal.assign.contract_id,
                    filter:null
                })
                    .then(response => {
                        this.modal.assign.tiers = response;
                        if(response.tier_1){
                            this.modal.assign.optionsSupplier = response.tier_1;
                            this.modal.assign.tierLevel = 1;
                        }else if(response.tier_2){
                            this.modal.assign.optionsSupplier = response.tier_2;
                            this.modal.assign.tierLevel = 2;
                        }else if(response.tier_3){
                            this.modal.assign.optionsSupplier = response.tier_3;
                            this.modal.assign.tierLevel = 3;
                        }
                    })
                    .catch( err => {
                        console.log(err)
                    })
            },
            showMoreSupplier(){
                switch (this.tierLevel) {
                    case 1:
                        this.modal.assign.supplier = this.modal.assign.supplier.concat(this.tiers.tier_2);
                        this.tierLevel = 2;
                        break;
                    case 2:
                        this.modal.assign.supplier = this.modal.assign.supplier.concat(this.tiers.tier_3);
                        this.tierLevel = 3;
                        break;
                }
            },
            async assignItems(){
                this.modal.assign.job_id = null
                if(this.modal.ids.length === 0){
                    return this.$alertNotification("Please select a record!", "danger");
                }
                this.modal.assign.ids = this.modal.ids;
                let equipment_ids = this.modal.assign.ids;
                let equipments = this.modal.assign.job_id = this.tableItems.filter(element =>
                    (
                        (equipment_ids.indexOf(element.id)!== -1) && !element.order_id && (element.coming_job_annual != null || element.coming_job_five_year != null)
                    )
                );

                if(equipments.length !== equipment_ids.length){
                    return this.$alertNotification("Please select a equipment with upcoming service!", "danger");
                }

                let job_ids = [];
                equipments.map(item => {
                    if(item.coming_job_annual && item.coming_job_annual.id) {
                        job_ids.push(item.coming_job_annual.id)
                    }

                    if(item.coming_job_five_year && item.coming_job_five_year.id) {
                        job_ids.push(item.coming_job_five_year.id)
                    }
                })
                this.modal.assign.job_id = job_ids;
                this.modal.assign.open = true;
                this.modal.assign.contract_id = (this.ClientContractID && this.ClientContractID.id) ? this.ClientContractID.id:null
                this.modal.assign.tierLevel = 1;
                this.getSupplier();
            },
            assignSupplier(){
                if (this.modal.assign.supplierAssign == null) {
                    return this.$alertNotification("Please select a supplier!", "danger");
                }
                this.modal.assign.loading = true;
                this.$store.dispatch("JobController/assignRunsheetSupplier", {
                    ids: this.modal.assign.job_id,
                    supplier: this.modal.assign.supplierAssign,
                    generate_order: this.modal.assign.generate_order,
                    filter: this.modal.assign.filter
                }).then(response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.modal.assign.supplierAssign = null;
                    this.modal.assign.generate_order = false;
                    this.modal.assign.open = false;
                    this.modal.assign.loading = false;
                    if (response.data.data.code === 200) {
                        return this.$alertNotification(this.$notificationV2('assigning', 'supplier'));
                    }
                })
                .catch(err => {
                    this.modal.assign.loading = false;
                    if(this.modal.assign.generate_order) {
                        return this.$alertNotification("Create Order failed. Line Items empty!", "danger");
                    }
                })
            },
            checkSchedule() {
                if(!this.modal.data.maintenance || !this.modal.data.equipment_list.length) return false;
                return this.modal.data.equipment_list.some(item => !this.modal.equipment_ids.includes(item.id));
            },
            showModalMassSchedule(item = null, type = '') {
                this.popupMaintPrograms     = this.maintPrograms.filter(item => item.id != 'all');
                this.modal.data.maintenance = this.maintProgram.id != 'all' ? this.maintProgram : null;

                if((type == '1Y' || type == '5Y') && this.maintProgram.id == 'all' && this.popupMaintPrograms.length) {
                    for(let i = 0; i < this.popupMaintPrograms.length; i++) {
                        let item = this.popupMaintPrograms[i];
                        if(item.get_sor_recurring_mode && item.get_sor_recurring_mode.recurring_mode && item.get_sor_recurring_mode.recurring_mode == type) {
                            this.modal.data.maintenance = item;
                            break;
                        }
                    }
                }

                if(item) {
                    this.property = JSON.parse(JSON.stringify(item.location_info));
                    this.modal.data.equipment_list = [{
                        id: item.id,
                        tag_name: item.tag_name
                    }];
                } else {
                    this.modal.data.equipment_list = this.tableItems.filter(item => this.modal.ids.includes(item.id));
                    if(this.maintProgram.location_info) this.property = JSON.parse(JSON.stringify(this.maintProgram.location_info));
                }

                //check: allow schedule
                if(!item) {
                    if(this.checkSchedule()) {
                        return this.$alertNotification("Scheduling is not possible because some rows have equipment groups and properties that are not part of the maintenance program you choose.", "danger");
                    }
                }

                this.modal.data.date = null;
                this.modal.status = false;
                this.modal.data.is_create_individual = false;
                this.job_id = null;
                // if(val && item){
                //     this.modal.data.date = (item.coming_job.planned_date != null) ? new Date(item.coming_job.planned_date) : null
                //     this.job_id = (item.coming_job != null)?item.coming_job.id:null
                //     this.modal.status = true;
                // }

                this.general.root_property_id = this.maintProgram.property_id;
                this.modal.data.client_contract_id = this.general.contract_id;
                this.modal.loading = false;
                this.modal.rescheduled.reason_rescheduled = null
                this.modal.open = true;
            },
            async getMaintProgram(search = null, is_popup = false) {
                let filters = {
                    search:             search,
                    contract_term_id:   this.general.contract_term_id,
                    is_maintenance:     true,
                    is_master:          false,
                    recurring_mode_one_and_five_year: true
                }

                await this.$store.dispatch("v2SorController/getItems", {
                    isCMS: false,
                    page: -1,
                    limit: 100,
                    group_id: 0,
                    filter: filters
                })
                .then(response => {
                    if(!is_popup) {
                        this.maintPrograms = [{
                            id: 'all',
                            description_one: 'All'
                        }].concat(response.items);
                    } else {
                        this.popupMaintPrograms = response.items;
                    }
                })
                .catch(err => {
                    this.maintPrograms = [];
                })
            },
            async searchMaintProgram(search, loading) {
                loading(true)
                this.maintPrograms = []
                if (this.timer.maint) {
                    clearTimeout(this.timer.maint);
                    this.timer.maint = null;
                }
                this.timer.maint = setTimeout(async () => {
                    try {

                        let is_popup = false;
                        if(this.modal.open)
                            is_popup = true;

                        await this.getMaintProgram(search, is_popup);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            checkScheduledJob() {
                if(this.modal.loading) return 
                if(!this.modal.data.equipment_list.length) {
                    return this.$alertNotification("Equipment tag(s) is required", "danger");
                }

                if(!this.isEquipmentSchedule && !this.modal.data.maintenance) {
                    return this.$alertNotification("Maintenance program is required", "danger");
                }

                if(!this.modal.data.date) {
                    return this.$alertNotification("Date is required", "danger");
                }

                if(moment(this.modal.data.date).isBefore(moment(), 'day')) {
                    return this.$alertNotification("The date must be greater than or equal to the current date.", "danger");
                }

                if(this.checkSchedule()) {
                    return this.$alertNotification("Scheduling is not possible because some equipment tag have equipment groups and properties that are not part of the maintenance program you choose.", "danger");
                }

                let request = {
                    equipment_list: this.modal.data.equipment_list,
                    maintenance_id: this.isEquipmentSchedule ? this.maintProgram.id : this.modal.data.maintenance.id,
                    planned_date:   moment(this.modal.data.date).format('YYYY-MM-DD')
                }

                this.modal.loading = true;
                if (this.timer.modal) {
                    clearTimeout(this.timer.modal);
                    this.timer.modal = null;
                }
                
                this.modal.errors.list = []
                this.is_same_date = false

                this.timer.modal = setTimeout(async () => {

                    this.$store.dispatch("EquipmentV2Controller/checkExpiredJobsRescheduling", request)
                    .then(async response => {
                        
                        let result = response.data.data;
                        if ( result && result.length > 0 ) {
                            if ( this.modal.data.equipment_list.length > 1 ) {

                                this.modal.loading = false
                                this.modal.errors.list = result
                                this.modal.errors.open = true
                                
                                return;
                            }

                            let id_ = (result[0] && result[0].id) ? result[0].id : null;
                            this.checkScheduledAndReschedule(request, id_);
                        } else {
                            this.checkScheduledAndReschedule(request);
                        }
                    })
                    .catch(err => {
                        this.modal.loading = false;
                        console.log(err);
                    })
                }, 200);
                // this.timer.modal = setTimeout(async () => {
                //     this.$store.dispatch("EquipmentV2Controller/checkScheduledJob", request)
                //     .then(response => {
                //         let result = response.data.data;

                //         if(!result.existing) {
                //             this.createAssetManagement();
                //             return;
                //         }

                //         this.modal.loading = false;
                //         this.modal.checkSchedule.open = true;
                //     })
                //     .catch(err => {
                //         this.modal.loading = false;
                //         console.log(err);
                //     })
                // }, 200);
            },
            checkScheduledAndReschedule(request, rescheduled_id = null) {
                if ( this.modal.data.equipment_list.length == 1 ) request.check_planned_date = 1;
                this.$store.dispatch("EquipmentV2Controller/checkScheduledJob", request)
                .then(async response => {
                    let result = response.data.data;

                    if ( result.is_same_date ) {
                        this.is_same_date = true
                    }
                    
                    if(!result.existing) {
                        if(rescheduled_id) {
                            this.modal.rescheduled.ids = [rescheduled_id];
                            this.modal.loading = false
                            this.modal.open = false
                            this.modal.rescheduled.open = true
                            return
                        }
                        this.createAssetManagement();
                        return;
                    }

                    this.modal.loading = false;
                    this.modal.checkSchedule.open = true;
                })
                .catch(err => {
                    this.modal.loading = false;
                    console.log(err);
                })
            },
            async reScheduledClick() {

                if(!this.modal.rescheduled.ids) {
                    return this.$alertNotification('Job is required', 'danger');
                }

                if(!this.modal.data.date) {
                    return this.$alertNotification('Start Date is required', 'danger');
                }

                if(!this.modal.rescheduled.reason_rescheduled) {
                    return this.$alertNotification('Reason is required', 'danger');
                }

                this.modal.rescheduled.loading = true

                let dataRes = {
                    ids: this.modal.rescheduled.ids,
                    start_date: moment(this.modal.data.date).format('YYYY-MM-DD'),
                    reason_rescheduled: this.modal.rescheduled.reason_rescheduled
                };

                await this.$store
                .dispatch("JobController/reScheduledRunsheet", dataRes)
                .then((result) => {
                    this.modal.rescheduled.open = false
                    this.modal.rescheduled.loading = false
                    this.modal.rescheduled.ids = []
                    this.modal.data.date = null
                    this.modal.rescheduled.reason_rescheduled = null
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.$alertNotification('Reschedule success!');
                })
                .catch((err) => {
                    this.modal.rescheduled.open = false
                    this.modal.rescheduled.loading = false
                    this.modal.rescheduled.ids = []
                    this.modal.data.date = null
                    this.modal.rescheduled.reason_rescheduled = null
                    if(err.response.data.error.message.error){
                        return this.$alertNotification(err.response.data.error.message.error, 'danger');
                    }
                });
            },
            overrideAssetManagement() {
                if(this.modal.loading) return 
                this.modal.loading = true;
                if (this.timer.modal) {
                    clearTimeout(this.timer.modal);
                    this.timer.modal = null;
                }
                this.timer.modal = setTimeout(async () => {
                    this.createAssetManagement();
                }, 200);
            },
            createAssetManagement() {
                this.modal.checkSchedule.open = false;
                this.modal.data.maintenance_id = this.isEquipmentSchedule ? this.maintProgram.id : this.modal.data.maintenance.id;
                let objeClone = JSON.parse(JSON.stringify(this.modal.data));
                objeClone.start_date = moment(objeClone.date).format('YYYY-MM-DD');
                objeClone.end_date = moment(objeClone.date).format('YYYY-MM-DD');
                objeClone.equipment_list = JSON.stringify(
                    objeClone.equipment_list.map(item => {
                        return {
                                id: item.id,
                                name: item.tag_name
                            };
                        })
                    );
                
                if(this.job_id){
                    this.$store.dispatch("JobController/updatePlannedDateRunsheet", {
                        data: {
                            date: objeClone.start_date
                        },
                        id: this.job_id,
                    }).then((result) => {
                        this.modal.open = false;
                        this.modal.loading = false;
                        this.getEquipment();
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2("editing", "job_list"));
                    })
                    .catch((err) => {
                        this.modal.loading = false;
                    });
                    return;
                }
                this.$store.dispatch("EquipmentV2Controller/createAssetManagement", objeClone)
                .then(response => {
                    this.modal.loading = false;
                    this.modal.open = false;
                    this.getEquipment();
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.$alertNotification(this.$notificationV2('adding', 'asset_management'));
                })
                .catch(err => {
                    this.modal.loading = false;
                    if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "warning");
                    }
                })
            },
            /* --- Equipment --- */
            async searchEquipment(search, loading) {
                loading(true)
                this.equipments = []
                if (this.timer.equipment) {
                    clearTimeout(this.timer.equipment);
                    this.timer.equipment = null;
                }
                this.timer.equipment = setTimeout(async () => {
                    try {
                        await this.getEquipment("", search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            async getEquipment(property_id = "", search = "") {
                if(this.general.contract_id) {
                    this.equipment_loading = true;
                    this.pagesEquipment.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                    this.pagesEquipment.filter.tag_name.value = search;
                    this.pagesEquipment.filter.contract_id.value = this.general.contract_id;
                    this.pagesEquipment.filter.location_id.value = property_id || this.general.property_id
                    this.pagesEquipment.filter.equipment_group_id.value = this.general.equipment_group_id;

                    if(this.modal.data.maintenance) {
                        this.pagesEquipment.maintenance_id = this.modal.data.maintenance.id;
                        this.pagesEquipment.maintenance_property_id = this.modal.data.maintenance.property_id;
                        this.pagesEquipment.maintenance_equipment_group_id = this.modal.data.maintenance.equipment_group_id;
                        this.pagesEquipment.recurring_mode = this.modal.data.maintenance.get_sor_recurring_mode ? this.modal.data.maintenance.get_sor_recurring_mode.recurring_mode : null;
                    } else if(this.maintProgram) {
                        this.pagesEquipment.maintenance_id = this.maintProgram.id;
                        this.pagesEquipment.maintenance_property_id = this.maintProgram.property_id;
                        this.pagesEquipment.maintenance_equipment_group_id = this.maintProgram.equipment_group_id;
                        this.pagesEquipment.recurring_mode = this.maintProgram.get_sor_recurring_mode ? this.maintProgram.get_sor_recurring_mode.recurring_mode : true;
                    }

                    await this.$store.dispatch("EquipmentV2Controller/getEquipments", this.pagesEquipment)
                    .then(response => {
                        this.equipment_loading = false;
                        this.equipments = response.data.data.items;
                        this.modal.equipment_ids = [];
                        if(response.data.data.equipment_ids) {
                            this.modal.equipment_ids = response.data.data.equipment_ids
                        }
                    })
                    .catch(err => {
                        this.equipment_loading = false;
                        console.log(err)
                    })
                }
            },
            async getTableData(callback){

                const { tableRequest , resolve,reject } = await callback();
                if(!this.general.contract_id) {
                    this.tableItems = [];
                    resolve({
                        items: [],
                        total: 0
                    });
                    return;
                }

                tableRequest.filter.contract_id.value =  this.general.contract_id;
                tableRequest.filter.location_id.value =  this.general.property_id;
                tableRequest.filter.equipment_group_id.value  = this.general.equipment_group_id;
                tableRequest.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                tableRequest.maintenance_id = this.maintProgram ? this.maintProgram.id : null;

                if(this.settings.showDropDownMaint) {
                    tableRequest.maintenance_property_id = this.maintProgram && this.maintProgram.property_id ? this.maintProgram.property_id : null;
                    tableRequest.maintenance_equipment_group_id = this.maintProgram && this.maintProgram.equipment_group_id ? this.maintProgram.equipment_group_id : null;
                    tableRequest.recurring_mode = this.maintProgram && this.maintProgram.get_sor_recurring_mode && this.maintProgram.get_sor_recurring_mode.recurring_mode ? this.maintProgram.get_sor_recurring_mode.recurring_mode : null;
                }
                tableRequest.table_name = this.nameTable;
                await this.$store.dispatch("EquipmentV2Controller/getEquipments", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        this.equipment_ids = this.modal.equipment_ids = [];
                        if(response.data.data.equipment_ids) {
                            this.equipment_ids = this.modal.equipment_ids = response.data.data.equipment_ids;
                        }
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the list", "danger");
                        reject();
                    })
            },
            reloadEquipment() {
                this.$refs.gofixTable.reloadTableItems();
            },

            /*--- Export File ---*/
            exportItems(tableRequest) {
                if(!this.ClientContractID || !this.ClientContractID.id)
                    return;
                let request = JSON.parse(JSON.stringify(tableRequest));
                request.filter.contract_id.value =  this.general.contract_id;
                request.filter.location_id.value =  this.general.property_id;
                request.filter.equipment_group_id.value  = this.general.equipment_group_id;
                request.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                request.maintenance_id = this.maintProgram ? this.maintProgram.id : null;
                request.limit = -1;
                this.$store.dispatch( 'EquipmentV2Controller/exportAssetManagement', {
                    tableRequest: request,
                    is_equipment_schedule: this.isEquipmentSchedule
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'AssetManagementList.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },

            /*--- Import File ---*/
            chaneFile() {
                this.isCheck = this.fileImport ? false : true
            },
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`AssetManagementController/import`, {
                    contract_id: this.general.contract_id,
                    file: file
                })
                    .then(response => {
                        let variant = 'success';
                        let msg = this.$notificationV2('importing', 'equipment');
                        let result = response.data.data;
                        if(result.data && result.data.count && result.data.count.failed ) {
                            variant = 'danger';
                            msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                        }

                        this.$alertNotification(msg, variant);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            },
            uploadFileImport() {
                if (!this.fileImport) {
                    return this.$alertNotification("Please choose file to import", "danger");
                }
                this.isAction = true;
                this.$store.dispatch(`EquipmentStructureController/uploadFileImport`, {
                    contract_id: this.general.contract_id,
                    file: this.fileImport,
                    is_master: false
                })
                    .then(response => {
                        this.$refs['modal-Import'].hide()
                        this.pages.filter.equipment_type.value = null
                        this.pages.filter.equipment_group_id.value = null
                        this.reloadEquipment();
                        this.loadingEquipmentStruct = true;
                        this.getCateData()
                        .then(result => {
                            this.loadingEquipmentStruct = false;
                            this.$refs.treeViewCategory.tree.setModel(result);
                        })

                        this.isAction = false;

                        let variant = 'success';
                        let msg = this.$notificationV2('importing', 'equipment');
                        let result = response.data.data;
                        if( result.data && result.data.count && result.data.count.failed ) {
                            variant = 'danger';
                            msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                        }

                        return this.$alertNotification(msg, variant);
                    })
                    .catch(err => {
                        this.isAction = false;
                        let msg = "Can't import data!";
                        if( err.response.data.error
                            && err.response.data.error.message
                        ) {
                            msg = err.response.data.error.message;
                        }

                        return this.$alertNotification(msg, "danger");
                    })
            },
            hiddenModalImport() {
                this.fileImport = null;
                this.isCheckImport = '';
            },
          resetImport(){
            this.modalImport.check = '';
            this.modalImport.file = null;
          },
          changeFile(){
            this.modalImport.check = this.modalImport.file ? false : true;
          },
          async importBackDateJob(){
            if(this.modalImport.loading) return ;
            if (!this.modalImport.file) {
              return this.$alertNotification("Please choose file to import", "danger");
            }
            this.modalImport.loading = true;
            await this.$store.dispatch(`AssetManagementController/importBackDateJob`, {
              contract_id: this.general.contract_id,
              file: this.modalImport.file
            })
                .then(response => {
                  let variant = 'success';
                  let msg = this.$notificationV2('importing', 'back_date_job');
                  let result = response.data.data;
                  if(result.data && result.data.count && result.data.count.failed ) {
                    variant = 'danger';
                    msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                  }
                  this.$alertNotification(msg, variant);
                  this.modalImport.open = false;
                  this.modalImport.loading = false;
                  this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err => {
                  this.modalImport.loading = false;
                  let msg = "Can't import data!";
                  if( err.response.data.error
                      && err.response.data.error.message
                  ) {
                    msg = err.response.data.error.message;
                  }

                  return this.$alertNotification(msg, "danger");
                });
          },
            downloadReportLiftPerAge(){
                this.modal.reportFomat.open = false
                this.$store.dispatch( 'EquipmentV2Controller/downloadReportLiftPerAge', {
                    contract_id: (this.ClientContractID && this.ClientContractID.id) ? this.ClientContractID.id:null
                })
                .then(response => {
                    let nameFile = 'quantity-of-lifts-per-age-group-years-and-lift-brand.xlsx';
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    console.log(error);
                });
            },
            openImportSchedule() {
                this.popupMaintPrograms     = this.maintPrograms.filter(item => item.id != 'all');
                this.modal.importSchedule.data.maintenance = this.maintProgram.id != 'all' ? this.maintProgram : null;

                this.modal.importSchedule.open = true;
                this.modal.importSchedule.file = null;
                this.modal.importSchedule.data.maintenance = null;
                this.modal.importSchedule.loading = false;
            },
            async importSchduledJobs(){
                if(this.modal.importSchedule.loading) return ;
                if (!this.modal.importSchedule.file) {
                    return this.$alertNotification("Please choose file to import", "danger");
                }
                if (!this.modal.importSchedule.data.maintenance) {
                    return this.$alertNotification("Please select maintenance program to import", "danger");
                }

                this.modal.importSchedule.loading = true;
                await this.$store.dispatch(`AssetManagementController/importSchduledJobs`, {
                    client_contract_id: this.general.contract_id,
                    file_import: this.modal.importSchedule.file,
                    maintenance_id: this.modal.importSchedule.data.maintenance.id,
                })
                    .then(response => {
                        if(response.data.error) {
                            this.modal.importSchedule.loading = false;
                            return this.$alertNotification(response.data.message, "danger");
                        }
                        let variant = 'success';
                        let msg = this.$notificationV2('importing', 'schedule_job');
                        let result = response.data.data;
                        if(result.data && result.data.count && result.data.count.failed ) {
                            variant = 'danger';
                            msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                        }
                        this.$alertNotification(msg, variant);
                        this.modal.importSchedule.open = false;
                        this.modal.importSchedule.loading = false;
                        this.$refs.gofixTable.reloadTableItems();
                    })
                    .catch(err => {
                        this.modal.importSchedule.loading = false;
                        let msg = "Can't import data!";
                        if( err.response.data.error
                            && err.response.data.error.message
                        ) {
                            msg = err.response.data.error.message;
                        }

                        return this.$alertNotification(msg, "danger");
                    });
            },
        }
    }
</script>
